import React from "react";
import styles from "./ThanksgivingDecor.module.css";
import SeasonalLottie, {
  LEAVES_PATH,
  TURKEY_POT_PATH,
  WALKING_TURKEY_PATH,
} from "./SeasonalLottie";

// SCRUM-933: Thanksgiving Sign-in theme (Figma node 7551:7929). Same rules as
// the Halloween theme: everything is decorative (aria-hidden, pointer-events:
// none in the CSS), so the sign-in form underneath works exactly as before,
// and the artwork in /public is only fetched while the theme is on.
const IMG = "/assets/images/thanksgiving";
// The ground leaves are the same Figma artwork (426478954_...) and crops as
// the Halloween theme's, as is the pumpkin by the tree, so those files are
// reused rather than duplicated.
const HALLOWEEN_IMG = "/assets/images/halloween";

// Page-level layer: falling leaves, wheat behind the card's top-right corner
// (blurred by the glass card), leaves on the ground, glowing pumpkins, the
// turkey peeking out of a pumpkin between the tree and the card, and a turkey
// walking along the bottom edge. Hidden below 900px (mobile keeps the card
// theme only).
export const ThanksgivingPageDecor = () => (
  <div className={styles.pageLayer} aria-hidden="true">
    {/* Three copies of the same sheaf, fanned (Figma 7642:3234/3277/3320). */}
    <img src={`${IMG}/wheat-sheaf.svg`} alt="" className={`${styles.sheaf} ${styles.sheafA}`} />
    <img src={`${IMG}/wheat-sheaf.svg`} alt="" className={`${styles.sheaf} ${styles.sheafB}`} />
    <img src={`${IMG}/wheat-sheaf.svg`} alt="" className={`${styles.sheaf} ${styles.sheafC}`} />

    <img src={`${HALLOWEEN_IMG}/ground-leaves-tree@2x.png`} alt="" className={styles.groundLeft} />
    <img src={`${HALLOWEEN_IMG}/ground-leaves-center@2x.png`} alt="" className={styles.groundCenter} />
    <img src={`${HALLOWEEN_IMG}/ground-leaves-center@2x.png`} alt="" className={styles.groundRight} />

    {/* Warm glow, wheat stalks and the turkey-in-a-pumpkin Lottie (Figma
      7642:3233, 7585:38474 / 32750, 7582:27155). */}
    <img src={`${IMG}/pot-glow.svg`} alt="" className={styles.potGlow} />
    <img src={`${IMG}/wheat-stalk.svg`} alt="" className={`${styles.stalk} ${styles.stalkLeft}`} />
    <img src={`${IMG}/wheat-stalk.svg`} alt="" className={`${styles.stalk} ${styles.stalkRight}`} />
    <SeasonalLottie path={TURKEY_POT_PATH} className={styles.turkeyPot} />

    <img src={`${HALLOWEEN_IMG}/pumpkin-small-left.svg`} alt="" className={styles.pumpkinLeft} />
    <img src={`${IMG}/pumpkin-right.svg`} alt="" className={styles.pumpkinRight} />

    {/* Figma 7579:1974: walks left to right along the bottom, then loops. */}
    <div className={styles.walker}>
      <SeasonalLottie path={WALKING_TURKEY_PATH} className={styles.walkerBody} />
    </div>

    <SeasonalLottie path={LEAVES_PATH} className={styles.leaves} fit="xMidYMid slice" />
  </div>
);

// Card-level layer, mobile only (the desktop design keeps the card itself
// plain): a sheaf over the card's top-right corner and a pumpkin in its
// bottom-right corner.
export const ThanksgivingCardDecor = () => (
  <div className={styles.cardLayer} aria-hidden="true">
    <img src={`${IMG}/wheat-sheaf.svg`} alt="" className={styles.sheafCard} />
    <img src={`${IMG}/pumpkin-right.svg`} alt="" className={styles.pumpkinCard} />
  </div>
);
